import './KeyFeatures.css';
import icon1 from './icon1.png';
import icon2 from './icon2.png';
import icon3 from './icon3.png';
import icon4 from './icon4.png';
import icon5 from './icon5.png';
import icon6 from './icon6.png';
import icon7 from './icon7.png';

export const KeyFeatures = () => {
    return (
        <>
        <div id="key-features">
            <div className='row text-center'>
                <h2>Key Features & Functions</h2>
                <p>RubyRock is combining blockchain technology with a traditional asset to create a secured, fully transparent, and efficient asset-backed NFT.</p>
            </div>
            <div className='row key-features'>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='orange-bg-icon bg-icon'>
                        <img src={icon1} alt="features"/>
                    </div>
                    <h5>Limited Supply</h5>
                    <p>RBY Token supply is limited to 327,000,000, which are all directly and unequivocally linked to the weight of the Ruby specimen which is 32,700 carats. This ensures a fully transparent and mathematical distribution of the Ruby’s economic rights.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='blue-bg-icon bg-icon'>
                        <img src={icon2} alt="features"/>
                    </div>
                    <h5>100% Backed by Real Asset</h5>
                    <p>RubyRock is directly linked to economic rights of a physical Ruby Specimen stone (i.e Asset-Backed NFT). Each NFT represents 1250 RBY Tokens, which are pegged to 0.125 carats of the Ruby Specimen; hence each NFT is 100% backed by the Ruby Specimen and its economic rights.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='red-bg-icon bg-icon'>
                        <img src={icon3} alt="features"/>
                    </div>
                    <h5>Stable Value</h5>
                    <p>Historically precious stones have been used as stable and reliable store of value; RubyRock is a representation of Ruby prices (1 of 3 key foundations), which have been very stable throughout all market conditions.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='green-bg-icon bg-icon'>
                        <img src={icon4} alt="features"/>
                    </div>
                    <h5>Diversification & Hedging</h5>
                    <p>Being pegged to a real asset which is uncorrelated to crypto prices, RubyRock offers a way to diversify crypto risk and market volatility, as well as hedge against inflation with a superior credit quality.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='orange-bg-icon bg-icon'>
                        <img src={icon5} alt="features"/>
                    </div>
                    <h5>P2P Exchanges & Payments</h5>
                    <p>RubyRock is a digital asset which can be easily and securely transferred anywhere at any time, which can be used as a trustworthy medium of exchange for Peer to Peer (P2P) transactions, while its asset-based peg (ruby specimen) is simple and transparent.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='red-bg-icon bg-icon'>
                        <img src={icon6} alt="features"/>
                    </div>
                    <h5>Art collecting</h5>
                    <p>Dynamic and continuous artwork throughout the life of the project; collaborations with several renowned and emerging artists, which will increase appeal for collectors and increase future value. In the coming phases various art related events will take place: online auction, live auction and various collaborations to add to the artistic value.</p>
                </div>
                <div className='col-xs-12 col-md-3 feature-item' data-aos="fade-up">
                    <div className='blue-bg-icon bg-icon'>
                        <img src={icon7} alt="features"/>
                    </div>
                    <h5>Long Term Position & Value Creation</h5>
                    <p>RubyRock offers a unique investment that offers long term value creation through the various phases, as detailed in our roadmap and included DeFi tools, rewards, artistic value, and much more.</p>
                </div>
            </div>
        </div>
        </>
    )
}